import { createSlice } from '@reduxjs/toolkit'

const heDaoTaoReducer = createSlice({
  name: 'heDaoTao',
  initialState: { id: 0, datas: [] },
  reducers: {
    setHeDaoTaoId: (state, action) => {
      return { ...state, id: action.payload }
    },
    setHeDaoTaos: (state, action) => {
      return { ...state, datas: action.payload }
    },
  },
})
const { actions, reducer } = heDaoTaoReducer
export const { setHeDaoTaoId, setHeDaoTaos } = actions
export default reducer
